import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=2f643bea&scoped=true"
import script from "./banner.vue?vue&type=script&lang=ts"
export * from "./banner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f643bea",
  null
  
)

export default component.exports